<template>
  <div>
    <v-chip label color="green white--text" v-bind="{ ...$props }" x-small>
      {{ roleName }}
    </v-chip>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EUserRole",
  props: {
    value: {
      type: Object,
    },
    link: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),

    roleName() {
      if (!this.value || !this.value.roles || !this.value.roles.length) {
        return "SEM PERFIL";
      }
      const role = this.value.roles[0].name;
      return this.$constants.roleLabels[role] || role;
    },
  },
};
</script>
